import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

interface StepType {
  label: string;
}

interface VerticalLinearStepperProps {
  activeStep: number;
  handleNext: () => void;
  handleBack: () => void;
  handleReset: () => void;
  steps: StepType[];
}

export const VerticalLinearStepper: React.FC<VerticalLinearStepperProps> = ({ activeStep, handleNext, handleBack, handleReset, steps }) => {
  return (
    <Box sx={{ maxWidth: 500, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stepper
        activeStep={activeStep}
        orientation='vertical'
        sx={{
          flex: '1',
          padding: '40px',
          background: 'none',
          '& .MuiStepConnector-line': {
            minHeight: '100px',
            borderColor: 'gray', // Default color for all connector lines (inactive)
          },
          '& .Mui-active .MuiStepConnector-line': {
            borderColor: '#FFFFFF', // Color for the connector line just before an active step
            color: '#FFFFFF',
            fontWeight: '1000!important',
          },
          '& .Mui-completed .MuiStepConnector-line': {
            borderColor: '#FFFFFF', // Color for connector lines before completed steps
            color: '#FFFFFF',
            fontWeight: '1000!important',
          },
          '& .MuiStepLabel-root .Mui-active': {
            color: '#FFFFFF', // circle color (ACTIVE)
          },
          '& .MuiStepIcon-root': {
            stroke: '#ACACAC', // circle color (INACTIVE)
          },
          '.css-9h4u2n-MuiStepLabel-label.Mui-active': {
            fontWeight: '1000!important',
            // color: rgba(255, 255, 255, 0.8)!important;
          },
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              sx={{
                '& .MuiStepLabel-label': {
                  fontSize: '16px', // Your desired font size
                  color: '#ACACAC', // Your desired color
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
